import React, { FC, useCallback, useState } from "react";

import { AddressView, OnboardingAside, OnboardingContent, Place, PrimaryAlternateControl } from "@xapp/components";

export interface AddressStepProps {
    /**
     * API Key for Google Places API
     */
    apiKey: string;
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * User has confirmed a place with name and address.  The place will be on the new props.
     */
    onPlaceSelected(place: Place): void;
    /**
     * Will add an optional button that allows the user to use the website instead of Google Business Profile
     */
    onUseWebsite(): void;
}

/**
 * V3 of our AddressStep, just asks for the address
 */
export const AddressStep: FC<AddressStepProps> = (props) => {
    const { apiKey, onPlaceSelected, onUseWebsite, aside } = props;

    const [place, setPlace] = useState<Place | null>(null);

    const handlePlace = (place: Place, valid: boolean) => {
        setPlace(place);
    };

    const handleContinueClicked = useCallback(() => {
        onPlaceSelected(place);
    }, [onPlaceSelected, place]);

    const disableContinue = !place || !place.name;

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <div style={{ minWidth: "400px" }}>
                    <AddressView
                        header={<h3>Find your Google Business Profile</h3>}
                        value={place}
                        apiKey={apiKey}
                        hideMap={true}
                        onChange={handlePlace}
                        searchOnly={true}
                        searchPlaceholder={"Search for business name..."}
                    />
                </div>

                <PrimaryAlternateControl
                    labels={{ primary: "Continue ➡️", alternate: "Use Website" }}
                    disabled={{ primary: disableContinue }}
                    onPrimary={handleContinueClicked}
                    onAlternate={onUseWebsite}
                />
            </OnboardingContent>
        </>
    );
};
